<div id="edit-cashflow-container">
  <p class="subheading-01-semi-bold">Nombre</p>
  <div id="input-container">
    <qr-input
      [config]="inputName"
      (valueChange)="inputChange($event)"
      [value]="this.name"
      [hasError]="hasError"
    ></qr-input>
  </div>
</div>
